import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue'
import { CheckIcon } from '@zhuowenli/vue-feather-icons'
import { Collapse } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultIndicator',
  props: {
  alertType: String,
},
  setup(__props, { expose: __expose }) {

const props = __props;


__expose({
  show,
  hide,
})

const collapseElem = ref<HTMLElement | null>(null)
const alertTypeClass = computed(() => "alert-" + props.alertType)

function show() {
  new Collapse(collapseElem.value!).show()
  setTimeout(() => hide(), 5000);
}

function hide() {
  if (collapseElem.value) {
    new Collapse(collapseElem.value).hide()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "collapseElem",
    ref: collapseElem,
    class: "collapse"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-sm page-alert", alertTypeClass.value]),
      role: "alert"
    }, [
      _createVNode(_unref(CheckIcon)),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("button", {
        type: "button",
        class: "btn-close float-end",
        onClick: hide,
        "aria-label": "Close"
      })
    ], 2)
  ], 512))
}
}

})